import Vue from 'vue'
import Vuex from 'vuex'
import { getToken } from '@/utils/auth';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getToken() || '',
    ClassID1: 0,
    ClassID2: -1,
  },
  getters: {
    getTokenValue: state => state.token,
    getClassID1Value: state => state.ClassID1,
    getClassID2Value: state => state.ClassID2,

  },
  mutations: {
    setTokenValue(state, tokenValue) { state.token = tokenValue },
    setClassID1Value(state, Value) { state.ClassID1 = Value },
    setClassID2Value(state, Value) { state.ClassID2 = Value },
  },
  actions: {

  },
  modules: {
  }
})
